<template>
	<div class="sa-free-page">
		<div class="sa-free-page-header">
			<div>
				<b-row>
					<b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
						<label class="sa-label-data">Titolo:</label>
						<b-form-input v-model="jsonData.title" placeholder="Titolo"></b-form-input>
					</b-col>
					<b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
						<label class="sa-label-data">Descrizione:</label>
						<b-form-input v-model="jsonData.descrizione" placeholder="Descrizione"></b-form-input>
					</b-col>
				</b-row>
			</div>
			<div>
				<div class="sa-free-page-toolbar">
					<label class="sa-label-data">Header Elements</label>
					<div class="sa-free-page-toolbar-separator"></div>
					<b-button size="sm" variant="outline-success pull-right" @click="onClickAggiungiHeader()"> <i class="fas fa-plus"></i> Aggiungi Elemento </b-button>
				</div>
				<b-row>
					<b-col v-for="headerElement in dashboard.headerElements" :key="headerElement.id" :cols="headerElement.cols" :xs="headerElement.xs" :sm="headerElement.sm" :md="headerElement.md" :lg="headerElement.lg" :xl="headerElement.xl">
						<data-analysis-dashboard-header-edit-component :chartParams="headerElement" @updateChart="onUpdateChart" @removeObject="onRemoveObjectHeadersElement"></data-analysis-dashboard-header-edit-component>
					</b-col>
				</b-row>
			</div>
		</div>
		<div class="sa-free-page-body">
			<div>
				<div class="sa-free-page-toolbar">
					<label class="sa-label-data">Body Elements</label>
					<div class="sa-free-page-toolbar-separator"></div>
					<b-button size="sm" variant="outline-success pull-right" @click="onClickAggiungiGrafico()"> <i class="fas fa-plus"></i> Aggiungi Elemento </b-button>
				</div>
				<b-row>
					<b-col v-for="bodyElement in dashboard.bodyElements" :key="bodyElement.id" :cols="bodyElement.cols" :xs="bodyElement.xs" :sm="bodyElement.sm" :md="bodyElement.md" :lg="bodyElement.lg" :xl="bodyElement.xl">
						<data-analysis-chart-edit-component :chartParams="bodyElement" @updateChart="onUpdateChart" @removeObject="onRemoveObjectBodyElement"></data-analysis-chart-edit-component>
					</b-col>
				</b-row>
			</div>
		</div>
		<div class="sa-free-page-footer"></div>
	</div>
</template>
<script>
import DataAnalysisDashboardHeaderEditComponent from "./DataAnalysisDashboardHeaderEditComponent.vue";
import DataAnalysisChartEditComponent from "./DataAnalysisChartEditComponent.vue";
import DataAnalysisDashboardMixin from "../mixins/DataAnalysisDashboardMixin";
export default {
	mixins: [DataAnalysisDashboardMixin],
	components: { DataAnalysisDashboardHeaderEditComponent, DataAnalysisChartEditComponent },
	data() {
		return {
			id: null,
			pathResource: "/dataanalysisdashboard",
			jsonData: { title: "", descrizione: "", dashboard: { headerElements: [], bodyElements: [] } },
			dashboard: { headerElements: [], bodyElements: [] },
		};
	},
	mounted() {
		let me = this;
		me.id = this.$route.params.id;
		if (me.id !== "-1") {
			me.loadData(); //<-Sta in DataAnalysisDashboardMixin
		} else {
			me.jsonData.dashboard = JSON.stringify(this.dashboard);
			this.$emit("updateDashBoard", me.jsonData);
		}
	},
	methods: {
		// loadData() {
		// 	let me = this;
		// 	let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
		// 	axios.get(link + me.id)
		// 		.then((response) => {
		// 			me.jsonData = response.data.data;
		// 			let tmpDashboard = JSON.parse(response.data.data.dashboard);
		// 			me.dashboard.headerElements = tmpDashboard.headerElements.sort((a, b) => a.position - b.position);
		// 			me.dashboard.bodyElements = tmpDashboard.bodyElements.sort((a, b) => a.position - b.position);
		// 			this.$emit("updateDashBoard", response.data.data);
		// 		})
		// 		.catch((e) => {
		// 			console.log(e);
		// 		});
		// },
		onUpdateChart() {
			let me = this;
			me.jsonData.dashboard = JSON.stringify(this.dashboard);
			this.$emit("updateDashBoard", me.jsonData);
		},
		onClickAggiungiGrafico() {
			let me = this;
			let chartObject = {
				id: me.dashboard.bodyElements.length + 1,
				title: "",
				idQuery: null,
				type: "graphic",
				graphicType: "bar",
				cols: 12,
				xs: 12,
				sm: 12,
				md: 12,
				lg: 6,
				xl: 6,
				xvalue: "",
				dimension: "",
				filters: "",
				filtersValue: "",
				filtroIniziale: "",
				position: me.dashboard.bodyElements.length + 1,
			};
			me.dashboard.bodyElements.push(chartObject);
		},
		onClickAggiungiHeader() {
			let me = this;
			let chartObject = {
				id: me.dashboard.headerElements.length + 1 + "-H",
				title: "",
				idQuery: null,
				cols: 6,
				xs: 6,
				sm: 6,
				md: 6,
				lg: 4,
				xl: 4,
				type: "numeric",
				position: me.dashboard.headerElements.length + 1,
			};
			me.dashboard.headerElements.push(chartObject);
		},
		onRemoveObjectHeadersElement(bodyElement) {
			this.dashboard.headerElements = this.dashboard.headerElements.filter((element) => element.id != bodyElement.id);
		},
		onRemoveObjectBodyElement(bodyElement) {
			this.dashboard.bodyElements = this.dashboard.bodyElements.filter((element) => element.id != bodyElement.id);
		},
	},
};
</script>

<style></style>
